// extracted by css-extract-rspack-plugin
export default {"cls1":"LoggedInDiscoveryPage-cls1_Bw_","cls2":"LoggedInDiscoveryPage-cls2_btr LoggedInDiscoveryPage-cls1_Bw_"};